import React from 'react';
import { ResourceRequest } from '@zawarski/eti-js-resourcerequest';
import { SheltersApp } from '@zawarski/eti-typescript-shelters';
import CountyIndicator from '@zawarski/palmetto-typescript-county-indicator';
import OperationalRhythm from '@zawarski/palmetto-typescript-operational-rhythm';
import CountyClosures from '@zawarski/palmetto-typescript-county-closures';
import Incidents from '@zawarski/palmetto-typescript-incidents';
import { SignificantEvents } from '@zawarski/palmetto-sigevents-library';
import { PositionLog as PositionLogApp } from '@zawarski/palmetto-typescript-positionlogs';
import BattleRhythm from '@zawarski/palmetto-typescript-battle-rhythm';
import PointOfDistribution from "@zawarski/point-of-distribution";

interface ProgramLibraryProps<T = unknown> {
  account?: T;
  appPermissions?: object;
  selectedid?: number;
  hosted?: boolean;
  login?: boolean;
  basePath?: string;
  userAuth?: { jwt: string };
  isFullScreen?: boolean;
  isAdmin?: boolean;
  highlightedDate?: string;
  dimensions?: {
    width: number;
    height: number;
  };
  displayView?: boolean;
  printView?: boolean;
  cbDisplayView?: () => void;
  cbPrintView?: (id: number) => void;
}

const ProgramsMap: Record<string, React.FC<ProgramLibraryProps<IUserPortal>>> = {
  '1': SignificantEvents as unknown as React.FC<ProgramLibraryProps<IUserPortal>>,
  '2': SheltersApp as unknown as React.FC<ProgramLibraryProps<IUserPortal>>,
  '3': ResourceRequest as unknown as React.FC<ProgramLibraryProps<IUserPortal>>,
  '7': Incidents as unknown as React.FC<ProgramLibraryProps<IUserPortal>>,
  '8': PositionLogApp as unknown as React.FC<ProgramLibraryProps<IUserPortal>>,
  '18': BattleRhythm as unknown as React.FC<ProgramLibraryProps<IUserPortal>>,
  '23': CountyIndicator as unknown as React.FC<ProgramLibraryProps<IUserPortal>>,
  '21': OperationalRhythm as unknown as React.FC<ProgramLibraryProps<IUserPortal>>,
  '22': CountyClosures as unknown as React.FC<ProgramLibraryProps<IUserPortal>>,
  '32': PointOfDistribution as unknown as React.FC<ProgramLibraryProps<IUserPortal>>,
};

export default ProgramsMap;
